module.exports = __webpack_public_path__ + "media/images/shared/ad/daizawamtr_postcardflyer-26f4d8c71a9fdf30dbbb00787b95dc29.jpg";